
<template>
      <h5>
            已有
            <span v-for="(item,index) in parnum" :key="index">{{item}}</span>
            人参与活动
        </h5>
</template>

<script>
export default {
  props:['cardActivityNo'],
  data () {
      return {
        parnum:'',
      }
    },
    created(){
      var m=this;
      //  查询参加人数
      this.HTTP.countUsernum(m.cardActivityNo).then((res) => {
             var num=res.body.content.count;
              num += '';
              m.parnum=num.split('');
        }, (err) => {
            console.log(err);
        });
    },
}
</script>

<style scoped>
    .card-box h5{
    width: 100%;
    text-align: center;
    font-size: .27rem;
    color: #a2fffe;
}
.card-box h5 span{
    display: inline-block;
    width: .42rem;
    height: .48rem;
    text-align: center;
    line-height: .48rem;
    border-radius: .1rem;
    background-color: #cf1d24;
    color: #a2fffe;
    font-size: .34rem;
    margin-right: .05rem;
}
</style>



// WEBPACK FOOTER //
// src/components/common/participate.vue